export enum AppointmentRequestStatus {
  Unconfirmed = 0, //Added
  Confirmed = 1,
  Cancelled = 2,
  Deleted = 255, //Dismissed
  New = 11,
  Pending = 12
}